<template>
  <div class="app">
    <h1>代理记账_记账报税_注册公司_人事社保_名企科技</h1>
    <Header :activeIndex="'3'"/>

    <!-- 这是代理记账这是代理记账 -->
    <nav class="tiaozhuan" aria-label="面包屑导航"><router-link to="/" style="cursor: pointer; color: inherit; text-decoration: none;">首页</router-link><span>&nbsp;&gt;&gt;&nbsp;</span><span>代理记账</span></nav>
    <div class="margintop">服务内容</div>
    <main class="juli">
      <table class="tableCSS">
        <thead>
          <tr>
            <th class="thCSS1">序号</th>
            <th class="thCSS">服务内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="tdCSS1">1</td>
            <td class="tdCSS">小规模代理记账</td>
          </tr>
          <tr>
            <td class="tdCSS1">2</td>
            <td class="tdCSS">一般纳税人代理记账</td>
          </tr>
          <tr>
            <td class="tdCSS1">3</td>
            <td class="tdCSS">个体户代理记账</td>
          </tr>
          <tr>
            <td class="tdCSS1">4</td>
            <td class="tdCSS">进出口代理记账</td>
          </tr>
          <tr>
            <td class="tdCSS1">5</td>
            <td class="tdCSS">高新企业代理记账</td>
          </tr>
          <tr>
            <td class="tdCSS1">6</td>
            <td class="tdCSS">总公司、分公司代理记账</td>
          </tr>
          <tr>
            <td class="tdCSS1">7</td>
            <td class="tdCSS">制作报账凭证</td>
          </tr>
          <tr>
            <td class="tdCSS1">8</td>
            <td class="tdCSS">编制财务报表（月度、季度、年度）</td>
          </tr>
          <tr>
            <td class="tdCSS1">9</td>
            <td class="tdCSS">纳税申报</td>
          </tr>
        </tbody>
      </table>
      <table class="tableCSS">
        <thead>
          <tr>
            <th class="thCSS1">序号</th>
            <th class="thCSS">服务内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="tdCSS1">10</td>
            <td class="tdCSS">填制相应税票（不含出口退税申报服务）</td>
          </tr>
          <tr>
            <td class="tdCSS1">11</td>
            <td class="tdCSS">员工个人所得税月度申报</td>
          </tr>
          <tr>
            <td class="tdCSS1">12</td>
            <td class="tdCSS">基本财务知识培训</td>
          </tr>
          <tr>
            <td class="tdCSS1">13</td>
            <td class="tdCSS">协助乙方接受税务检查工作</td>
          </tr>
          <tr>
            <td class="tdCSS1">14</td>
            <td class="tdCSS">税务优化，税务优惠政策分析</td>
          </tr>
          <tr>
            <td class="tdCSS1">15</td>
            <td class="tdCSS">制定并打印账本、报表</td>
          </tr>
          <tr>
            <td class="tdCSS1">16</td>
            <td class="tdCSS">申报残保金</td>
          </tr>
          <tr>
            <td class="tdCSS1">17</td>
            <td class="tdCSS">打印银行回单</td>
          </tr>
          <tr>
            <td class="tdCSS1">18</td>
            <td class="tdCSS">税务汇算清缴</td>
          </tr>
        </tbody>
      </table>
    </main>

    <!-- <h2 class="youshi">我们的报价</h2>
    <div style="text-align: center;margin-left: auto;margin-right: auto;">
      <div>小规模：260/月</div>
      <div>一般人：550/月</div>
      <div>说明：我们都是明码标价，标准定价，不会因为客户的票据多了随意涨价~</div>
    </div> -->


    <Youshi />
    <Footer />
  </div>
</template>
  
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Youshi from '@/components/Youshi.vue'

export default {
  name: 'jizhang',
  components: {
    Header,
    Footer,
    Youshi
  },
  data() {
    return {
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      pppclose: true
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
  },
  methods: {
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen');
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathJizhang() {
      this.$router.push('/jizhang');
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathxinxi() {
      this.$router.push('/xinxi')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
  }
}
</script>
  
<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }
}
</style>
  
<style scoped>
/* 服务内容 */
.juli {
  margin-left: 20%;
  margin-right: 20%;
  display: flex;
  gap: 20px;
}

.tableCSS {
  width: 90%;
  border-collapse: collapse;
  margin: 0 auto;
}

.tdCSS1 {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-weight: bold;
  font-style: italic;
  color: #d22525;
  height:25px;
}

.tdCSS {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.thCSS1 {
  background-color: #f2f2f2;
  padding: 8px;
  text-align: center;
  border: 1px solid #ddd;
  width: 35px;
  height:25px;
}

.thCSS {
  background-color: #f2f2f2;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
  border: 1px solid #ddd;
}

ul,
li {
  margin: 0;
  padding: 0;
}

.box {
  width: 250px;
  height: 190px;
  background-color: #037dfb91;
  margin-left: 6px;
  margin-top: 6px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.goodtitle {
  font-size: 23px;
  color: #fdfcb8;
  /* font-family: 'fangzheng', sans-serif; */
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-weight: 550;
  transform: scaleX(1.2) scaleY(2.5);
  line-height: 60px;
}

.goodtext {
  font-size: 19px;
  color: #fdfcb8;
  /* font-family: 'fangzheng', sans-serif; */
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  margin-top: 8px;
}


/* 其他 */
ul,
li {
  margin: 0;
  padding: 0;

}

h1 {
  font-size: 0%;
}

.margintop {
  margin-left: auto;
  margin-right: auto;
  font-size: 25px;
  margin-bottom: 11px;
  font-weight: 700;
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  /* font-family: 'msyh', sans-serif; */
}

.tiaozhuan {
  text-align: left;
  margin-bottom: 0.83em;
  margin-top: 118px;
  margin-left: 19.5%;
  font-size:18px;
  font-weight: 500;
}


@media (max-width: 768px) {
  /* 服务内容 */
  .juli {
    margin-left: 3%;
    margin-right: 3%;
    display: flex;
    gap: 10px;
  }

  .tableCSS {
    width: 90%;
    border-collapse: collapse;
    margin: 0 auto;
    font-size: 13px;
  }

  .tdCSS1 {
    border: 1px solid #ddd;
    padding: 1px;
    text-align: center;
    font-weight: bold;
    font-style: italic;
    color: #d22525;
    height: 25px;
  }

  .tdCSS {
    border: 1px solid #ddd;
    padding: 1px;
    text-align: left;
  }

  .thCSS1 {
    background-color: #f2f2f2;
    padding: 1px;
    text-align: center;
    border: 1px solid #ddd;
    width: 30px;
    height: 25px;
  }

  .thCSS {
    background-color: #f2f2f2;
    padding-left: 1px;
    padding-right: 1px;
    text-align: center;
    border: 1px solid #ddd;
  }

  /* 其他 */
  .margintop {
    margin-left: auto;
    margin-right: auto;
    margin-bottom:5px;
    font-size: 15px;
  }

  .tiaozhuan {
    text-align: left;
    margin-bottom: 0.83em;
    margin-top: 100px;
    margin-left: 2%;
    font-size:11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jizhang.vue